import React, { useRef, useEffect } from "react";
import ForceGraph3D from "react-force-graph-3d";
import ForceGraph2D from "react-force-graph-2d";
//import { data } from "./testData";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "https://esm.sh/three/examples/jsm/renderers/CSS2DRenderer.js";
const Graph = ({ data, title }) => {
  const fgRef = useRef();
  useEffect(() => {
    //alert({ title });
    if (fgRef.current) {
      fgRef.current.d3Force("charge").strength(-200);
      fgRef.current.d3Force("link").distance(100);
    }
  }, []);
  const width = 2400;
  const height = 800;

  return (
    <>
      <div className="chartTitle">{title}</div>
      <div>
        <ForceGraph2D
          width={width}
          height={height}
          graphData={data}
          nodeLabel={(node) =>
            `<div style="width: 200px; 
        display: inline-block;
        background-color: whitesmoke; 
        border-radius: 10px;
        padding: 10px; 
        font-size: 14px; 
        color:#282828">
        <div style="
        font-size: 16px; 
        background-color: #123458;
        color:whitesmoke">
         <center><b>${node.id}</b></center>
        </div><br/>
        <div>
        Type: <b>${node.type}</b>
        </div>
        </div>`
          }
          //Node pop up label

          //Link popup label
          //linkLabel="MOT"
          linkLabel={(link) =>
            `<div style="width: 200px; 
        display: inline-block;
        background-color: whitesmoke; 
        border-radius: 10px;
        padding: 10px; 
        font-size: 14px; 
        color:#282828">
        <div style="
        font-size: 16px; 
        background-color: #123458;
        color:whitesmoke">
         <center><b>${link.from || ""} to ${link.to || ""}</b></center>
        </div><br/>
        <div>
        Mode: <b>${link.MOT}</b>
        </div>
        <div>
        Lead Time (Days): <b>${link.value}</b>
        </div>
        </div>`
          }
          //Background color of the network graph
          backgroundColor="#282828"
          nodeAutoColorBy="type"
          linkAutoColorBy="MOT"
          enableNodeDrag={false}
          //linkColor={(link) => link.color || "gray"}
          linkDirectionalArrowLength={5}
          linkDirectionalArrowRelPos={1}
          linkDirectionalParticles={(d) => (1 / d.value) * 5}
          linkDirectionalParticleSpeed={(d) => (1 / d.value) * 0.005}
          linkCanvasObject={(link, ctx) => {
            const { source, target } = link;
            const start = { x: source.x, y: source.y };
            const end = { x: target.x, y: target.y };

            // Calculate the midpoint of the link
            const midpoint = {
              x: (start.x + end.x) / 2,
              y: (start.y + end.y) / 2,
            };
            ctx.beginPath();
            ctx.moveTo(source.x, source.y);
            ctx.lineTo(target.x, target.y);
            ctx.stroke();
            // Set text properties
            ctx.font = "8px Arial";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = link.color;

            // Draw the label
            ctx.fillText(link.MOT, midpoint.x, midpoint.y);
          }}
          linkCanvasObjectMode={() => "after"}
          /*
      linkCanvasObject={(link, ctx) => {
        const { source, target } = link;
        const label = link.MOT;
        ctx.beginPath();
        ctx.moveTo(source.x, source.y);
        ctx.lineTo(target.x, target.y);
        ctx.stroke();
        ctx.fillStyle = link.color;
        const textX = (source.x + target.x) / 2;
        const textY = (source.y + target.y) / 2;

        ctx.font = "12px Arial";
        ctx.textAlign = "center";
        ctx.fillText(label, textX, textY);
      }} */
          nodeCanvasObject={(node, ctx, globalScale) => {
            const label = node.id;
            const fontSize = 18 / globalScale;

            const textWidth = ctx.measureText(label).width;
            const bckgDimensions = [textWidth, fontSize].map(
              (n) => n + fontSize * 0.2
            ); // some padding
            // Draw node
            ctx.beginPath();
            ctx.arc(node.x, node.y, 8, 0, 2 * Math.PI, false);
            ctx.fillStyle = "#383838";
            ctx.fill();

            ctx.font = `12px Arial`;
            ctx.fillStyle = "transparent";
            ctx.fillRect(
              node.x - bckgDimensions[0] / 2,
              node.y - bckgDimensions[1] / 2,
              ...bckgDimensions
            );

            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = node.color;
            ctx.fillText(label, node.x, node.y);

            node.__bckgDimensions = bckgDimensions; // to re-use in nodePointerAreaPaint
          }}
          cooldownTicks={100}
          onEngineStop={() => fgRef.current.zoomToFit(400)}
          nodeThreeObject={(node) => {
            const nodeEl = document.createElement("div");
            nodeEl.textContent = node.id;
            nodeEl.style.color = node.color;
            nodeEl.className = "node-label";
            return new CSS2DObject(nodeEl);
          }}
          nodeThreeObjectExtend={true}
          ref={fgRef}
        />
      </div>
    </>
  );
};

export default Graph;
